require('./bootstrap');

import angular from "angular";
import angularAnimate from "angular-animate";
import angularTouch from "angular-touch";
import angularSanitize from "angular-sanitize";
import uiBootstrap from "angular1-ui-bootstrap4";
import angularFilter from "angular-filter";
import angularScroll from "angular-scroll";
import ngFileUpload from "ng-file-upload";
import angularMoment from "angular-moment";
require('ng-mask');
// import ngMask from "ng-mask";

angular
    .module('app', [
        angularAnimate,
        angularTouch,
        angularSanitize,
        uiBootstrap,
        angularFilter,
        angularScroll,
        ngFileUpload,
        angularMoment,
        'ngMask',
    ])
    .run(['$templateCache', function ($templateCache) {
            $templateCache.put("uib/template/pagination/pagination.html",
                "<li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"page-item pagination-first\"><a href class=\"page-link\" ng-click=\"selectPage(1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle><i class=\"fas fa-arrow-circle-left\"></i></a></li>\n" +
                "<li ng-if=\"::directionLinks\" ng-class=\"{disabled: noPrevious()||ngDisabled}\" class=\"page-item pagination-prev\"><a href class=\"page-link\" ng-click=\"selectPage(page - 1, $event)\" ng-disabled=\"noPrevious()||ngDisabled\" uib-tabindex-toggle><i class=\"fas fa-arrow-left\"></i></a></li>\n" +
                "<li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=\"page-item pagination-page\"><a href class=\"page-link\" ng-click=\"selectPage(page.number, $event)\" ng-disabled=\"ngDisabled&&!page.active\" uib-tabindex-toggle>{{page.text}}</a></li>\n" +
                "<li ng-if=\"::directionLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"page-item pagination-next\"><a href class=\"page-link\" ng-click=\"selectPage(page + 1, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle><i class=\"fas fa-arrow-right\"></i></a></li>\n" +
                "<li ng-if=\"::boundaryLinks\" ng-class=\"{disabled: noNext()||ngDisabled}\" class=\"page-item pagination-last\"><a href class=\"page-link\" ng-click=\"selectPage(totalPages, $event)\" ng-disabled=\"noNext()||ngDisabled\" uib-tabindex-toggle><i class=\"fas fa-arrow-circle-right\"></i></a></li>\n" +
                "");
    }])
    .controller('MainController', ['$scope', '$uibModal', '$http', function ($scope, $uibModal, $http) {
            $scope.moderatorAddDetailModal = (name) => {
                    $http.post('/moderator/others/get-categories').then((res) => {
                            $uibModal.open({
                                    component: 'moderatorAddDetailModal',
                                    size: 'lg',
                                    resolve: {
                                            name: function () {
                                                    return name;
                                            },
                                            categories: function () {
                                                    return res.data.categories;
                                            }
                                    }
                            });
                    });
            };

            $scope.moderatorBindDetailModal = name => {
                $http.post('/moderator/others/get-categories').then((res) => {
                    $uibModal.open({
                        component: 'moderatorBindDetailModal',
                        size: 'lg',
                        resolve: {
                            name: function () {
                                return name;
                            },
                            categories: function () {
                                return res.data.categories;
                            }
                        }
                    });
                });
            };
    }]);

require('./components/df-application-form/df-application-form');
require('./components/df-application-add-detail/df-application-add-detail');
require('./components/application-show-form/application-show-form');
require('./components/car-history-page/car-history-page');
require('./components/tr-index-page/tr-index-page');
require('./components/fin-application-reply-form/fin-application-reply-form');
require('./components/car-history-applications-page/car-history-applications-page');
require('./components/tr-application-reply-form/tr-application-reply-form');
require('./components/buh-application-reply-form/buh-application-reply-form');
require('./components/car-history-mileage-page/car-history-mileage-page');
require('./components/tr-change-mileage-modal/tr-change-mileage-modal');
require('./components/moderator-add-detail-modal/moderator-add-detail-modal');
require('./components/df-application-accept-show/df-application-accept-show');
require('./components/df-set-user-modal/df-set-user-modal');
require('./components/moderator-application-edit/moderator-application-edit');
require('./components/df-index-page/df-index-page');
require('./components/df-applications-report-page/df-applications-report-page');

require('./components/applications-report/applications-report');
require('./components/moderator-bind-detail-modal/moderator-bind-detail-modal');
